import { axios } from "../../helpers/axios";
import { CUSTOMER_URL, CUSTOMERS_URL } from "./customerConstants";

export const api_get_customer_list_url = async (page, limit, qn, qs) => {
    // Backend uses /customers for list
    return axios.get(CUSTOMERS_URL, { params: { page, limit, qn, qs } });
};

export const api_create_customer_url = async (data) => {
    // Backend uses /customer for create (POST)
    return axios.post(CUSTOMER_URL, data);
};

export const api_update_customer_url = async (customer_id, updated_data) => {
    // Backend uses /customers/{id} for update (PUT)
    return axios.put(CUSTOMERS_URL + "/" + customer_id, updated_data);
};

export const api_activate_deactivate_customer_url = async (customer_id, updated_data) => {
    // Backend uses /customer/{id}/{activation_type} for patch
    return axios.patch(CUSTOMER_URL + "/" + customer_id + "/" + updated_data);
};

export const api_get_customer_details_url = async (customer_id) => {
    // Backend uses /customers/{id} for details
    return axios.get(CUSTOMERS_URL + "/" + customer_id);
};
